import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { ReactComponent as AdminLogo } from '../../../assets/icons/AdminLogo.svg';
import s from './Login.module.css';

export const Login: React.FC = () => {
    const navigate = useNavigate();
    const { login } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            await login(email, password);
            navigate('/admin/news');
        } catch (err) {
            setError('Неверный email или пароль');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={s.loginPage}>
            <div className={s.loginCard}>
                <div className={s.logoWrapper}>
                    <AdminLogo className={s.logo} />
                </div>
                <h1 className={s.title}>Авторизация</h1>
                <form onSubmit={handleSubmit} className={s.form}>
                    <div className={s.formGroup}>
                        <label className={s.label}>Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className={s.input}
                            placeholder="admin@example.com"
                            required
                        />
                    </div>
                    <div className={s.formGroup}>
                        <label className={s.label}>Пароль</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className={s.input}
                            placeholder="••••••••"
                            required
                        />
                    </div>
                    {error && <div className={s.error}>{error}</div>}
                    <button type="submit" className={s.submitBtn} disabled={loading}>
                        {loading ? 'Вход...' : 'Войти'}
                    </button>
                </form>
            </div>
        </div>
    );
};